<template>
  <div>


    <head>

      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet"
            type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
            type="text/css"/>

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
            rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

    </head>

    <body @contextmenu.prevent data-sidebar="dark">

    <!-- Begin page -->
    <div id="layout-wrapper">


      <NavigationBar/>

      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div id="content" class="content-minimize">

        <div class="page-content">
          <div class="container-fluid">

            <!-- start page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">UNPAID BILLS</h4>

                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a>
                      </li>
                      <li class="breadcrumb-item active">unpaid bills</li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>

            <ToolBarFire/>
            <!-- end page title -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100"
                         role="toolbar">
                      <h4 class="card-title text-capitalize mb-0 ">
                        All Paid Bills
                      </h4>

                      <div class="d-flex">
                        <a v-if="getRight('FIRE LICENCE CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize"
                           type="button">
                          <i class="mdi mdi-plus-circle-outline  font-size-16"></i> <span
                            class="pl-1 d-md-inline">Create A Bill</span>
                        </a>

                      </div>


                    </div>
                    <div class="btn-toolbar p-3 align-items-center d-none animated delete-tool-bar"
                         role="toolbar">
                      <button class="btn btn-primary waves-effect btn-label waves-light me-3"
                              type="button"><i class="mdi mdi-printer label-icon"></i> Print
                        Selected Invoices
                      </button>
                    </div>
                  </div>

                  <div class="card-header bg-white pt-2">
                    <div class="row align-items-end">
                      <div class="col-md-3 col-sm-6 mb-2">
                        <small class="text-uppercase fw-semibold mb-1 d-block">Search</small>
                        <div class="search-box">
                          <div class="position-relative">
                            <input v-model="search" type="text" class="form-control form-control-sm bg-light border-light rounded" placeholder="Bill No, Name, Phone...">
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-6 mb-2">
                        <small class="text-uppercase fw-semibold mb-1 d-block">Date Range</small>
                        <div class="d-flex align-items-center gap-1">
                          <input class="form-control form-control-sm" type="date" v-model="dateFrom">
                          <span class="text-muted px-1">to</span>
                          <input class="form-control form-control-sm" type="date" v-model="dateTo">
                        </div>
                      </div>
                      <div class="col-md-3 col-sm-6 mb-2">
                        <small class="text-uppercase fw-semibold mb-1 d-block">Filter By</small>
                        <div class="d-flex gap-1">
                          <select class="form-select form-select-sm" v-model="filter">
                            <option selected value="filter-all">All</option>
                            <option value="filter-sub-county">Sub County</option>
                            <option value="filter-wards">Ward</option>
                            <option value="filer-zone">Zone</option>
                            <option value="filter-officer">Officer</option>
                          </select>
                          <select class="form-select form-select-sm" data-live-search="true" v-model="selectedItem" v-if="itemList.length > 0">
                            <option :key="index" :value="item.value" v-for="(item, index) in itemList">{{ item.value }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-2 col-sm-6 mb-2 text-end">
                        <small class="text-muted d-block">Revenue Collected</small>
                        <h5 class="mb-0 text-success">KES {{numberFormat(summary.total)}}</h5>
                        <small class="badge bg-success">{{numberFormat(summary.count)}} bills</small>
                      </div>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">

                      <table class="table align-middle table-hover table-striped mb-0"
                             id="datatable-buttons">
                        <thead>
                        <tr class="table-dark" style="font-size: 12px;">
                          <th scope="col" style="width:40px;">#</th>
                          <th scope="col">Bill No</th>
                          <th scope="col">Description</th>
                          <th scope="col">Location</th>
                          <th scope="col">Attendant</th>
                          <th scope="col" class="text-end">Billed</th>
                          <th scope="col" class="text-end">Paid</th>
                          <th scope="col" class="text-center">Status</th>
                          <th scope="col" style="width:40px;"></th>
                        </tr>
                        </thead>
                        <tbody style="font-size: 13px;">
                        <tr :key="index" :value="item" v-for="(item, index) in billDetails">
                          <td class="text-muted">{{index+1}}</td>
                          <td>
                            <a href="javascript:void(0);" @click="getBill(item.billNo)" data-target="#billDetail" data-toggle="modal" class="text-primary fw-semibold" style="font-size: 12px;">
                              {{item.billNo}}
                            </a>
                            <div class="text-muted" style="font-size: 11px;">{{formatDate(item.dateCreated)}}</div>
                          </td>
                          <td>
                            <div class="text-capitalize" style="max-width: 220px;">{{item.feeDescription}}</div>
                          </td>
                          <td>
                            <div class="text-capitalize" style="font-size: 12px;">{{item.subCountyName}}</div>
                            <div class="text-muted text-capitalize" style="font-size: 11px;">{{item.wardName}} <span v-if="item.zone">· {{item.zone}}</span></div>
                          </td>
                          <td>
                            <span class="text-capitalize" style="font-size: 12px;">{{item.names}}</span>
                          </td>
                          <td class="text-end">
                            <span class="fw-semibold" style="font-size: 12px;">{{numberFormat(item.detailAmount)}}</span>
                          </td>
                          <td class="text-end">
                            <span class="fw-semibold text-success" style="font-size: 12px;">{{numberFormat(item.receiptAmount)}}</span>
                            <div v-if="Number(item.billBalance) > 0" class="text-danger" style="font-size: 11px;">Bal: {{numberFormat(item.billBalance)}}</div>
                          </td>
                          <td class="text-center">
                            <span class="badge badge-soft-success" style="font-size: 10px;" v-if="item.status==='PAID'">PAID</span>
                            <span class="badge badge-soft-danger" style="font-size: 10px;" v-else>UNPAID</span>
                          </td>
                          <td>
                            <div class="dropdown">
                              <a aria-haspopup="true" class="text-muted font-size-16" data-bs-toggle="dropdown" role="button">
                                <i class="bx bx-dots-vertical-rounded"></i>
                              </a>
                              <div class="dropdown-menu dropdown-menu-end">
                                <a class="dropdown-item" href="javascript:void(0);" @click="getBill(item.billNo)" data-target="#billDetail" data-toggle="modal">
                                  <i class="font-size-15 mdi mdi-eye me-2"></i>View Details
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark" style="font-size: 12px;">
                        <tr>
                          <th>{{billDetails.length}}</th>
                          <th colspan="4">Total Bills</th>
                          <th class="text-end">{{totalDetailAmount}}</th>
                          <th class="text-end">{{totalReceiptAmount}}</th>
                          <th></th>
                          <th></th>
                        </tr>
                        </tfoot>
                      </table>

                      <div v-if="loading" class="px-5 py-5 d-flex flex-column align-items-center text-center">
                        <div class="spinner-border text-info m-1" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                        <h6 class="text-uppercase mt-3">Loading Data</h6>
                        <p class="text-muted col-lg-5">Fetching records, please wait...</p>
                      </div>
                      <div v-if="billDetails.length<1 && loading===false" class="px-5 py-5 d-flex flex-column align-items-center text-center">
                        <img :src="'./assets/images/no-results.png'" class="img mb-4" style="max-width: 120px;" alt="No search results"/>
                        <h6>No Results Found</h6>
                        <p class="text-muted">Try different search keywords or filter criteria.</p>
                      </div>

                    </div>
                  </div>
                  <div class="card-footer bg-white py-2">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <small class="text-muted me-2">Rows:</small>
                        <select class="form-select form-select-sm w-auto" v-model="pageSize" style="font-size: 12px;">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                          <option value="1000000000000">All</option>
                        </select>
                      </div>

                      <ul class="pagination pagination-sm mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <a class="page-link" @click="prevPage" :disabled="currentPage === 1">‹ Prev</a>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next ›</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

            <!-- end row -->
          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

        <!-- receipting modal -->
        <div aria-hidden="true" aria-labelledby="myLargeModalLabel" class="modal fade receipting-modal"
             id="billDetail" role="dialog" tabindex="-1">
          <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myLargeModalLabel">Bill details</h5>
                <button aria-label="Close" class="btn-close" data-dismiss="modal"
                        type="button"></button>
              </div>
              <div class="modal-body">

                <!-- ✅ Explanation / How-To Guide -->
                <div class="alert alert-light border mb-4">
                  <h6 class="alert-heading fw-bold mb-2"><i class="mdi mdi-information-outline me-1 text-primary"></i> How to Link a Business for Fire Inspection</h6>
                  <p class="mb-2 text-muted font-size-13">This modal allows you to view bill details and link a business to a specific fee item for fire inspection. Follow the steps below:</p>
                  <div class="d-flex align-items-start mb-1">
                    <span class="badge bg-primary rounded-circle me-2 mt-1" style="width:22px; height:22px; line-height:16px; font-size:12px;">1</span>
                    <span class="font-size-13"><strong>Review the bill</strong> — Check the bill summary, customer details, and all the line items listed below.</span>
                  </div>
                  <div class="d-flex align-items-start mb-1">
                    <span class="badge bg-primary rounded-circle me-2 mt-1" style="width:22px; height:22px; line-height:16px; font-size:12px;">2</span>
                    <span class="font-size-13"><strong>Select a fee item</strong> — Click on the specific fee/line item you want to link a business to (e.g. Fire Inspection fee).</span>
                  </div>
                  <div class="d-flex align-items-start mb-1">
                    <span class="badge bg-primary rounded-circle me-2 mt-1" style="width:22px; height:22px; line-height:16px; font-size:12px;">3</span>
                    <span class="font-size-13"><strong>Search and select a business</strong> — A search box will appear. Type to find the business by name, ID, or owner, then click to select it.</span>
                  </div>
                  <div class="d-flex align-items-start">
                    <span class="badge bg-primary rounded-circle me-2 mt-1" style="width:22px; height:22px; line-height:16px; font-size:12px;">4</span>
                    <span class="font-size-13"><strong>Initiate Inspection</strong> — Once both are selected, click the <strong class="text-danger">"Initiate Inspection"</strong> button to link the business and update the records.</span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <address>
                      <strong class="text-capitalize">Bill Prepared for:</strong><br>
                      {{billDetail.description}}<br>
                      <br>
                      On {{billDetail.dateCreated}}
                    </address>
                  </div>
                  <div class="col-sm-6 text-sm-end">
                    <address class="mt-2 mt-sm-0">
                      <strong>Bill No:</strong><br>
                      <span class="fw-medium">{{billNo}}</span><br>
                      <strong>Status:</strong>
                      <span class="badge badge-soft-success text-uppercase" v-if="billDetail.status==='PAID'">{{billDetail.status}}</span>
                      <span class="badge badge-soft-danger text-uppercase" v-else>UNPAID</span><br>
                      <strong>Transaction Code:</strong> {{billDetail.transactionCode || 'N/A'}}<br>
                      <strong>Source:</strong> {{billDetail.source || 'N/A'}}
                    </address>
                  </div>
                </div>

                <!-- ✅ Bill Summary Row -->
                <div class="d-flex align-items-center mb-2">
                  <span class="badge bg-primary rounded-circle me-2" style="width:24px; height:24px; line-height:18px; font-size:13px;">1</span>
                  <h6 class="font-size-14 fw-bold mb-0">Review Bill Summary</h6>
                </div>
                <div class="row mb-3">
                  <div class="col-4">
                    <div class="border rounded p-2 text-center">
                      <small class="text-muted">Billed Amount</small>
                      <h5 class="mb-0 text-primary">{{formatPrice(billDetail.detailAmount)}}</h5>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="border rounded p-2 text-center">
                      <small class="text-muted">Amount Paid</small>
                      <h5 class="mb-0 text-success">{{formatPrice(billDetail.receiptAmount)}}</h5>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="border rounded p-2 text-center">
                      <small class="text-muted">Balance</small>
                      <h5 class="mb-0" :class="Number(billDetail.billBalance) > 0 ? 'text-danger' : 'text-success'">{{formatPrice(billDetail.billBalance)}}</h5>
                    </div>
                  </div>
                </div>

                <!-- ✅ Customer & Officer Info -->
                <div class="row mb-3">
                  <div class="col-6">
                    <small class="text-muted text-uppercase fw-semibold">Customer Details</small>
                    <p class="mb-1"><strong>Phone:</strong> {{billDetail.customerPhoneNumber || 'N/A'}}</p>
                    <p class="mb-1"><strong>Sub County:</strong> {{billDetail.subCountyName || 'N/A'}}</p>
                    <p class="mb-1"><strong>Ward:</strong> {{billDetail.wardName || 'N/A'}}</p>
                    <p class="mb-0"><strong>Zone:</strong> {{billDetail.zone || 'N/A'}}</p>
                  </div>
                  <div class="col-6">
                    <small class="text-muted text-uppercase fw-semibold">Officer Details</small>
                    <p class="mb-1"><strong>Created By:</strong> {{billDetail.names || 'N/A'}}</p>
                    <p class="mb-1"><strong>Phone:</strong> {{billDetail.phoneNumber || 'N/A'}}</p>
                    <p class="mb-1"><strong>Category:</strong> {{billDetail.category || 'N/A'}}</p>
                    <p class="mb-0"><strong>Department:</strong> {{billDetail.department || 'N/A'}}</p>
                  </div>
                </div>

                <!-- ✅ Bill Line Items Table -->
                <div class="col-12">
                  <div class="py-2 mt-3 d-flex align-items-center">
                    <span class="badge bg-primary rounded-circle me-2" style="width:24px; height:24px; line-height:18px; font-size:13px;">2</span>
                    <h3 class="font-size-15 fw-bold mb-0">Select a Fee Item ({{billInfo.length}} items)</h3>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-nowrap table-striped vertical-align-middle">
                      <thead class="table-light">
                      <tr>
                        <th style="width: 20px;"></th>
                        <th>#</th>
                        <th>Fee Description</th>
                        <th>Stream</th>
                        <th>Customer</th>
                        <th class="text-center">Qty</th>
                        <th class="text-right">Bill Total</th>
                        <th class="text-right">Paid</th>
                        <th class="text-right">Balance</th>
                        <th>Status</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in billInfo" :key="'bill-'+index"
                          :class="{'table-primary': selectedBillInfoItem && selectedBillInfoItem.id === item.id}"
                          @click="selectBillInfoItem(item)"
                          style="cursor: pointer;">
                        <td>
                          <input type="radio" :checked="selectedBillInfoItem && selectedBillInfoItem.id === item.id" @change="selectBillInfoItem(item)">
                        </td>
                        <td>{{index + 1}}</td>
                        <td>{{item.feeDescription}}</td>
                        <td><span class="badge bg-info">{{item.incomeTypePrefix || 'N/A'}}</span></td>
                        <td>{{item.customer || item.description}}</td>
                        <td class="text-center">{{item.quantity || 1}}</td>
                        <td class="text-right fw-semibold">{{formatPrice(item.billTotal)}}</td>
                        <td class="text-right fw-semibold text-success">{{formatPrice(item.receiptAmount)}}</td>
                        <td class="text-right fw-semibold" :class="Number(item.billBalance) > 0 ? 'text-danger' : ''">{{formatPrice(item.billBalance)}}</td>
                        <td>
                          <span class="badge badge-soft-success text-uppercase" v-if="item.status==='PAID'">{{item.status}}</span>
                          <span class="badge badge-soft-danger text-uppercase" v-else>UNPAID</span>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-light">
                      <tr>
                        <th></th>
                        <th colspan="5" class="text-right">Totals:</th>
                        <th class="text-right">{{formatPrice(billInfoTotalBilled)}}</th>
                        <th class="text-right text-success">{{formatPrice(billInfoTotalPaid)}}</th>
                        <th class="text-right" :class="billInfoTotalBalance > 0 ? 'text-danger' : ''">{{formatPrice(billInfoTotalBalance)}}</th>
                        <th></th>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <hr>

                <!-- ✅ Business Linking Section - only shows after selecting a bill line item -->
                <div v-if="selectedBillInfoItem">
                  <div class="col-12">
                    <div class="py-2 d-flex align-items-center">
                      <span class="badge bg-primary rounded-circle me-2" style="width:24px; height:24px; line-height:18px; font-size:13px;">3</span>
                      <h3 class="font-size-15 fw-bold mb-0">Search & Select a Business</h3>
                    </div>
                    <div class="alert alert-info d-flex align-items-center mb-3">
                      <i class="mdi mdi-information-outline font-size-18 me-2"></i>
                      <div>
                        <strong>Selected Fee:</strong> {{selectedBillInfoItem.feeDescription}}
                        <span class="badge bg-info ms-2">{{selectedBillInfoItem.incomeTypePrefix || 'N/A'}}</span>
                        <span class="ms-2">|</span>
                        <span class="ms-2"><strong>Amount:</strong> {{formatPrice(selectedBillInfoItem.billTotal)}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="py-2 search-box mb-3 me-4">
                    <div class="position-relative">
                      <input v-model="keyword" type="text" class="form-control bg-light border-light rounded" placeholder="Search business by name, ID, or owner...">
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="table-responsive">
                      <table class="table table-nowrap vertical-align-middle">
                        <thead class="bg-light">
                        <tr>
                          <th style="width: 20px;"></th>
                          <th style="width: 70px;">Business ID</th>
                          <th>Business Name</th>
                          <th>Owner</th>
                          <th>Sub Category</th>
                          <th>SubCounty</th>
                          <th>Ward</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in businesses" :key="'biz-'+index"
                            :class="{'table-primary': selectedBusinessID === item.businessID}"
                            @click="toggleSelection(item.businessID)"
                            style="cursor: pointer;">
                          <td>
                            <input type="radio" :checked="selectedBusinessID === item.businessID" @change="toggleSelection(item.businessID)">
                          </td>
                          <td>{{ item.businessID }}</td>
                          <td>{{ item.businessName }}</td>
                          <td>{{ item.fullNames }} <a href="javascript: void(0);"> {{item.ownerPhone}}</a></td>
                          <td>{{ item.businessSubCategory }}</td>
                          <td>{{ item.subCountyName }}</td>
                          <td>{{ item.wardName }}</td>
                        </tr>
                        <tr v-if="businesses.length === 0">
                          <td colspan="7" class="text-center text-muted py-3">Search for a business above to link it</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div v-else class="text-center text-muted py-4">
                  <i class="mdi mdi-hand-pointing-up font-size-36 d-block mb-2 text-primary"></i>
                  <h6 class="fw-semibold">Step 2: Select a Bill Line Item Above</h6>
                  <p class="font-size-13 mb-0">Click on a row in the Bill Line Items table to select the fee you want to link to a business.</p>
                </div>
              </div>
              <div class="modal-footer d-flex justify-content-between">

                <div class="d-flex align-items-center">
                  <span v-if="selectedBillInfoItem" class="badge bg-primary me-2 p-2">
                    <i class="mdi mdi-check-circle me-1"></i> Fee: {{selectedBillInfoItem.feeDescription.substring(0, 40)}}...
                  </span>
                  <span v-if="selectedBusinessID" class="badge bg-success me-2 p-2">
                    <i class="mdi mdi-check-circle me-1"></i> Business: {{selectedBusinessID}}
                  </span>
                </div>

                <div>
                  <button v-if="selectedBusinessID != null && selectedBillInfoItem != null"
                          @click="generateEntryCert(billDetail.billNo)"
                          class="btn btn-danger waves-effect waves-light text-nowrap me-3"
                          type="button">
                    <i class="mdi mdi-fire me-1"></i> Step 4: Initiate Inspection
                  </button>

                  <a @click="printBill()" class="btn btn-primary waves-effect waves-light" type="button">
                    <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Bill
                  </a>
                </div>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- end of receipting modal -->


        <footer class="footer ">
          <div class="container-fluid ">
            <div class="row ">
              <div class="col-sm-6 ">
                <!--                                <script>-->
                <!--                                    document.write(new Date().getFullYear())-->
                <!--                                </script> © RevenueSure-->
              </div>
              <div class="col-sm-6 ">
                <div class="text-sm-end d-sm-block ">
                  Developed by County
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <!-- end main content-->

    </div>
    <!-- END layout-wrapper -->

    </body>

  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, fire, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import ToolBar from "@/components/sbp/ToolBar";
import ToolBarFire from "@/components/fire/ToolBarFire.vue";

export default {
  name: "FirePaidBills",
  components: {ToolBarFire, ToolBar, NavigationBar},
  data() {
    return {
      keyword:'',
      selectedFeeID: null,
      selectedBusinessID: null,
      selectedBillInfoItem: null,
      search:'',
      loading: false,
      // set the initial current page as 1
      currentPage: 1,
      // set the total number of pages as 10 (you can change this according to your data source)
      totalPages: 0,
      // set the number of items per page as 5 (you can change this according to your preference)
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },


      totalAmount: null,
      selectedItem: null,
      valueItem: "",
      subCounty: "",
      itemList: [{
        id: null,
        value: null
      }],
      subCounties: [{
        subCountyID: "",
        subCountyName: ""
      }],
      wards: [{
        wardID: "",
        wardName: ""
      }],
      filter: '',
      dateFrom: '',
      dateTo: '',
      message: '',
      alert: {
        success: false,
        info: false,
        failed: false
      },
      billDetails: [
        {
          receiptAmount: "0",
        }

      ],
      billInfo: [],
      receiptInfos: [],
      billDetail: {
        id: "179",
        billNo: "BLL0411031700",
        incomeTypeID: "2,",
        incomeTypeDescription: "Informal Sector Fees,",
        costCenterNo: "",
        accountNo: ",",
        feeID: "18,",
        detailAmount: "1",
        receiptAmount: "1",
        billBalance: "0",
        wardID: "472751373",
        subCountyID: "47275",
        status: "PAID",
        dateCreated: "2023-04-11 12:17:00.192127"
      },
      billInfoTotal: 0,
      billNo: '',
      businesses: [{
        id: null,
        businessID: null,
        businessName: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        plotNumber: null,
        physicalAddress: null ,
        buildingName: null,
        buildingOccupancy:null ,
        floorNo:null ,
        roomNo: null,
        premiseSize: null,
        numberOfEmployees: null,
        tonnage: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        incomeTypeID: null,
        feeID: null,
        businessEmail:null ,
        postalAddress: null,
        postalCode:null ,
        businessPhone: null,
        contactPersonNames:null,
        contactPersonIDNo: null,
        businessRole: null,
        contactPersonPhone: null,
        contactPersonEmail: null,
        fullNames:null ,
        ownerID:null ,
        ownerPhone: null,
        ownerEmail:null ,
        kraPin:null ,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        lat: null,
        lng: null,
        fireLicence: null,
        liquorLicence: null,
        businessType: null,
        businessStatus: null
      }],
      business: {
        id: null,
        businessID: null,
        businessName: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        plotNumber: null,
        physicalAddress: null ,
        buildingName: null,
        buildingOccupancy:null ,
        floorNo:null ,
        roomNo: null,
        premiseSize: null,
        numberOfEmployees: null,
        tonnage: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        incomeTypeID: null,
        feeID: null,
        businessEmail:null ,
        postalAddress: null,
        postalCode:null ,
        businessPhone: null,
        contactPersonNames:null,
        contactPersonIDNo: null,
        businessRole: null,
        contactPersonPhone: null,
        contactPersonEmail: null,
        fullNames:null ,
        ownerID:null ,
        ownerPhone: null,
        ownerEmail:null ,
        kraPin:null ,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        lat: null,
        lng: null,
        fireLicence: null,
        liquorLicence: null,
        businessType: null
      },
    }


  },
  watch: {
    //pagination code
    // define a watcher for the pageSize property
    pageSize(newPageSize) {
      this.getBills()
      // get the total number of items from your data source (you can change this according to your logic)
      const totalItems = this.summary.count;
      // calculate the new total pages by dividing the total items by the new page size and rounding up
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      // update the totalPages data property with the new value
      this.totalPages = newTotalPages;
      // reset the current page to 1
      this.currentPage = 1;

    },

    search(){
      // ✅ Reset to page 1 when searching
      this.currentPage = 1;
      this.getBills()
    },
    keyword(){
      this.getBusinesses(this.keyword)
    }

  },
  computed: {
    //pagination code
    // calculate the start index of the items for the current page
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    // calculate the end index of the items for the current page
    endIndex() {
      return this.currentPage * this.pageSize;
    },

    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.receiptAmount), 0));
    }, totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.billBalance), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.detailAmount), 0));
    },
    // ✅ Bill Info modal totals
    billInfoTotalBilled() {
      return this.billInfo.reduce((sum, item) => sum + Number(item.billTotal || 0), 0);
    },
    billInfoTotalPaid() {
      return this.billInfo.reduce((sum, item) => sum + Number(item.receiptAmount || 0), 0);
    },
    billInfoTotalBalance() {
      return this.billInfo.reduce((sum, item) => sum + Number(item.billBalance || 0), 0);
    }

  },
  mounted() {

    this.menuAccess()

    this.businesses.splice(0)
    this.getBills()

    this.$watch('selectedItem', function (newValue) {
      this.getBills()
    })

    this.$watch('dateFrom', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {

      } else {
        this.getBills()
      }

    })
    this.$watch('dateTo', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {

      } else {
        this.getBills()
      }
    })

    this.$watch('filter', function (newValue) {

      if (newValue === 'filter-all') {
        this.getBills()
      }

      if (newValue === 'filter-sub-county') {
        this.getSubCounties()
      }
      if (newValue === 'filter-wards') {
        this.getWards()
      }

      if (newValue === 'filer-zone') {
        this.getZones()
      }
      if (newValue === 'filter-officer') {
        this.getUsers()
      }


    })
  },
  methods: {

    menuAccess(){

      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Fire Paid Bills");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
            // alert(res.data.message);
          })
          .catch((e) => {
            // alert(e.message);
          });

    },

    toggleSelection(businessID) {
      this.selectedBusinessID = (this.selectedBusinessID === businessID) ? null : businessID;
    },

    selectBillInfoItem(item) {
      // Toggle selection - deselect if already selected
      if (this.selectedBillInfoItem && this.selectedBillInfoItem.id === item.id) {
        this.selectedBillInfoItem = null;
      } else {
        this.selectedBillInfoItem = item;
      }
      // Reset business selection when changing fee item
      this.selectedBusinessID = null;
      this.businesses.splice(0);
      this.keyword = '';
    },

    deleteSelectedItems() {
      const itemsToDelete = [];
      this.selectedItems.forEach((isSelected, index) => {
        if (isSelected) {
          itemsToDelete.push(index);
        }
      });
      // Iterate in reverse order to safely remove items
      for (let i = itemsToDelete.length - 1; i >= 0; i--) {
        const index = itemsToDelete[i];
        this.billInfo.splice(index, 1);
        this.selectedItems.splice(index, 1);
      }
    },
    getRight(type){
      return getRight(type)
    },
    //pagination code
    pagination(currentPage, totalPages, maxVisibleButtons) {
      //initialize an empty array for the pages
      let pages = [];
      //calculate the start and end indices of the visible buttons
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);
      //adjust the start and end indices if they are out of bounds
      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }
      //loop through the start and end indices and push the pages to the array
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      //add an ellipsis at the beginning if there are more pages before the start index
      if (start > 1) {
        pages.unshift("...");
      }
      //add an ellipsis at the end if there are more pages after the end index
      if (end < totalPages) {
        pages.push("...");
      }
// return the array of pages
      return pages;
    },
    // define a method to go to the previous page
    prevPage() {
      // check if the current page is not the first page
      if (this.currentPage > 1) {
        // decrement the current page by 1
        this.currentPage--;
        this.getBills()
      }
    },
    // define a method to go to the next page
    nextPage() {
      // check if the current page is not the last page
      if (this.currentPage < this.totalPages) {
        // increment the current page by 1
        this.currentPage++;
        this.getBills()
      }
    },
    // define a method to go to a specific page
    goToPage(page) {
      // check if the page is valid and not equal to the current page
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        // set the current page to the given page
        this.currentPage = page;
        this.getBills()
      }
    },

    //number format
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },
    formatPrice(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      try {
        const d = new Date(dateStr);
        return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) + ' ' + d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      } catch (e) {
        return dateStr;
      }
    },
    gotTo(route) {
      router.push(route)
    },

    // ✅ FIXED: getBills now uses this.search directly instead of a hardcoded keyword
    getBills() {
      this.billDetails.splice(0)
      this.loading = true
      const data = new FormData();
      data.append("function", "getBillsPaginate");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("incomeTypePrefix", "FIREINSPECTION");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      // ✅ Pass the actual search keyword from the search input
      data.append("keyword", this.search);

      execute(data, biller)
          .then((res) => {
            this.loading = false
            this.summary.count =0
            this.summary.total =0

            this.totalAmount = null
            if (res.data.success) {
              this.billDetails = res.data.data.billDetails
              this.summary = res.data.data.summary
              this.totalPages =  Math.ceil(this.summary.count / this.pageSize);

              //Initialize the accumulator to 0
              this.totalAmount = this.billDetails.reduce((acc, cur) => {
                let receiptAmount = Number(cur.receiptAmount);
                return acc + receiptAmount;
              }, 0);

            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message
          });
    },
    getBusinesses(keyword) {
      const data = new FormData();
      data.append("function", "getBusinesses");
      data.append("keyword", keyword)
      execute(data, fire)
          .then((res) => {
            if (res.data.success) {
              this.businesses = res.data.data.businesses
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message
          });
    },
    getBill(billNo) {
      this.billNo = billNo
      // Reset selections when opening modal
      this.selectedBillInfoItem = null;
      this.selectedBusinessID = null;
      this.businesses.splice(0);
      this.keyword = '';

      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", billNo);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.billInfo = res.data.data.billInfo
              this.billDetail = res.data.data.billDetails
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message
          });
    },
    generateEntryCert(billNo) {
      if (!this.selectedBillInfoItem || !this.selectedBusinessID) {
        alert('Please select both a bill line item and a business');
        return;
      }

      const customer = 'Business ID:' + this.selectedBusinessID;

      // Step 1: Update the customer on the selected billInfo item
      const data = new FormData();
      data.append("function", "updateCustomer");
      data.append("id", this.selectedBillInfoItem.id);
      data.append("billNo", billNo);
      data.append("customer", customer);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {

              // Step 2: Call updateServiceRecordsForBill
              const data2 = new FormData();
              data2.append("function", "updateServiceRecordsForBill");
              data2.append("billNo", billNo);

              execute(data2, biller)
                  .then((res2) => {
                    if (res2.data.success) {
                      alert('Business ID:' + this.selectedBusinessID + ' linked successfully and records updated');
                      // Refresh bill details
                      this.getBill(billNo);
                      // Reset selections
                      this.selectedBusinessID = null;
                      this.selectedBillInfoItem = null;
                      this.businesses.splice(0);
                      this.keyword = '';
                    } else {
                      alert(res2.data.message || 'Failed to update service records');
                    }
                  })
                  .catch((e) => {
                    alert('Error updating service records: ' + e.message);
                  });

            } else {
              alert(res.data.message || 'Failed to update customer');
            }
          })
          .catch((e) => {
            alert('Error: ' + e.message);
          });
    },
    printBill() {
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetail.billNo
      })
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },
    getSubCounties() {
      this.itemList.splice(0)
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {

              res.data.data

              //Assuming subCounties and itemList are arrays of objects
              for (let i = 0; i < res.data.data.length; i++) {
                let subCounty = res.data.data[i];
                let item = {
                  id: subCounty.subCountyID,
                  value: subCounty.subCountyName
                };

                this.itemList.push(item);
              }


            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },
    getWards() {
      this.itemList.splice(0)
      const data = new FormData();
      data.append("function", "getWards");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {


              for (let i = 0; i < res.data.data.length; i++) {
                let ward = res.data.data[i];
                let item = {
                  id: ward.wardID,
                  value: ward.wardName
                };

                this.itemList.push(item);

              }


            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },
    getZones() {
      this.itemList.splice(0)
      const data = new FormData();
      data.append("function", "getZones");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {

              for (let i = 0; i < res.data.data.zones.length; i++) {
                let zone = res.data.data.zones[i];
                let item = {
                  id: zone.id,
                  value: zone.zone
                };

                this.itemList.push(item);
              }

            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message
          });
    },
    getUsers() {
      this.itemList.splice(0)
      const data = new FormData();
      data.append("function", "getUsers")
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              for (let i = 0; i < res.data.data.users.length; i++) {
                let user = res.data.data.users[i];
                let item = {
                  id: user.id,
                  value: user.names
                };

                this.itemList.push(item);
              }


            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            //alert(e.message);
            this.message = e.message
          });
    },
  }
}
</script>